import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../styles/home.css';

export default function Home() {
  const { isAuthenticated } = useAuth();

  return (
    <div className="home-container">
      <div className="hero">
        <h1 className="hero-title">
          Nintendo DS Emulator
          <br />
          <span className="gradient-text">In Your Browser</span>
        </h1>
        <p className="hero-subtitle">
          Play your favorite Nintendo DS games directly in your browser with cloud save synchronization
        </p>

        <div className="hero-actions">
          {isAuthenticated ? (
            <Link to="/dashboard" className="btn btn-primary btn-large">
              Go to Dashboard
            </Link>
          ) : (
            <>
              <Link to="/register" className="btn btn-primary btn-large">
                Get Started
              </Link>
              <Link to="/login" className="btn btn-secondary btn-large">
                Login
              </Link>
            </>
          )}
        </div>
      </div>

      <div className="features">
        <h2>Features</h2>
        <div className="features-grid">
          <div className="feature-card">
            <h3>Browser-Based</h3>
            <p>Play DS games directly in your browser, no downloads required</p>
          </div>
          <div className="feature-card">
            <h3>Cloud Saves</h3>
            <p>Your game progress is automatically synced to the cloud</p>
          </div>
          <div className="feature-card">
            <h3>Keyboard Controls</h3>
            <p>Customizable keyboard mappings for all DS buttons</p>
          </div>
          <div className="feature-card">
            <h3>Touch Support</h3>
            <p>Mouse-based touch screen simulation for interactive games</p>
          </div>
        </div>
      </div>

      <div className="legal-section">
        <h3>Legal Notice</h3>
        <p>
          This emulator does not provide any copyrighted content including ROMs, BIOS files, or games.
          Users must provide their own legally obtained ROM files. This project is for educational
          purposes and personal use only.
        </p>
      </div>
    </div>
  );
}
